import { getApiClient } from '@/api-client/api-client';
import { InsertUser } from '@/api-client/autogenerated';

export const getCurrentUser = async () => {
  const res = await getApiClient().getCurrentUser();
  return res.data;
};

export const loginUser = async (username: string, password: string) => {
  const res = await getApiClient().login({ loginRequest: { username, password } });
  return res.data;
};

export const logoutUser = async () => {
  return getApiClient().logout();
};

export const registerUser = async (params: InsertUser) => {
  const res = await getApiClient().register({ insertUser: params });
  return res.data;
};

export const updatePassword = async (password: string) => {
  const res = await getApiClient().changePassword({ changePasswordRequest: { password } });
  return res.data;
};

export const updateUsername = async (username: string) => {
  const res = await getApiClient().updateUsername({ updateUsernameRequest: { username } });
  return res.data;
};

export const requestPasswordReset = async (usernameOrEmail: string) => {
  const res = await getApiClient().forgotPassword({
    forgotPasswordRequest: { usernameOrEmail },
  });
  return res.data;
};
